import {
  GOOGLE_MAP_API_KEY
} from '../constants/APIKeys-obfuscated';
import {projectConfig} from '../project-info/projectConfig';
import {jsonOrThrow} from '../utils/Helpers';

export default class googleAPI {
  static geocode = (address) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address,
    )}&key=${GOOGLE_MAP_API_KEY}`;
    return fetch(url).then(jsonOrThrow);
  };

  static reverseGeocode = (latitude, longitude) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAP_API_KEY}`;
    return fetch(url).then(jsonOrThrow);
  };

  static autocomplete = (input, sessionToken, type) => {
    let url = `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${input}&key=${GOOGLE_MAP_API_KEY}&sessiontoken=${sessionToken}&types=${type}&`;
    if (!projectConfig.allowsOtherCountries) {
      url = `${url}&components=country:${projectConfig.primaryCountryCode}`;
    }
    return fetch(url).then(jsonOrThrow);
  };

  static timezone = (lat, long, timestamp_string) => {
    const url = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${long}&timestamp=${timestamp_string}&key=${GOOGLE_MAP_API_KEY}`;
    return fetch(url).then(jsonOrThrow);
  };
}
